import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { environment } from 'src/environments/environment';
import { GeneralInfo } from '../../models/entity/genaralInfo.model';
import { Introduce } from '../../models/entity/introduce.model';
import { Page } from '../../models/entity/page.model';
import { Partner } from '../../models/entity/partner.model';
import { Service } from '../../models/entity/service.model';
import { FilterBaseModel } from '../../models/viewModel/filterBase.model';
import { GeneralInfoService } from '../../services/api/generalInfo.service';
import { IntroduceService } from '../../services/api/introduce.service';
import { PageService } from '../../services/api/page.service';
import { PartnerService } from '../../services/api/partner.service';
import { ServicesService } from '../../services/api/services.service';
import { SocialService } from '../../services/api/social.service';
import { BreadcrumbService } from '../../services/local/breadcrumb.service';
import { MsgService } from '../../services/local/msg.service';
import { BaseComponent } from '../baseComponent';

@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styles: [
  ]
})
export class FooterComponent extends BaseComponent implements OnInit {
  // ------------ [Config] ------------
  filterService: FilterBaseModel = new FilterBaseModel();
  // ------------ [Data] ------------
  generalInfo: GeneralInfo = new GeneralInfo();
  services: Service[] = [];
  filterPartner: FilterBaseModel = new FilterBaseModel();
  partners: Partner[] = [];
  menus: Page[] = [];
  socials: any[] = [];
  introduce: Introduce = new Introduce();

  constructor(
    // ------------ [Base Constructor] ------------
    protected messageService: MsgService,
    protected router: Router,
    protected breadcrumbService: BreadcrumbService,
    // ------------ [Service Constructor] ------------
    protected generalInfoService: GeneralInfoService,
    protected servicesService: ServicesService,
    protected partnerService: PartnerService,
    protected pageService: PageService,
    protected socialService: SocialService,
    protected introduceService: IntroduceService
  ) {
    super(messageService, router);
  }

  ngOnInit(): void {
    this.initData();
  }
  // ------------ [Data] ------------
  async initData(): Promise<any> {
    this.getMenu();
    this.getSocials();
    this.getIntroduce();
    await this.getGeneralInfo();
    await this.getServices();
    await this.getPartners();
  }
  
  async getIntroduce(): Promise<any> {
    let filterModel: FilterBaseModel = new FilterBaseModel();
    filterModel.pageSize = 5;
    const res = await this.introduceService.getListIntroduces(filterModel);
    if (res.length > 0) {
      this.introduce = res.find(f => f.orderNumber == 1);
    }
  }

  async getSocials(): Promise<any> {
    this.filterService.pageSize = 6;
    const rep = await this.socialService.getAll();
    if (rep.data.length > 0) {
      this.socials = rep.data as [];
      // this.socials = this.socials.sort(s => -s.id);
    } else {
      this.socials = [];
    }
  }

  async getMenu(): Promise<any> {
    const result = await this.pageService.getListPagePublic();
    if (result.data.length > 0) {
      this.menus = result.data;
      this.menus = this.menus.sort((a, b) => a.pageOrder - b.pageOrder);
    }
  }

  async getGeneralInfo(): Promise<any> {
    const rep = await this.generalInfoService.getGeneralInfo();
    if (rep) {
      this.generalInfo = rep;
    } else {
      this.generalInfo = new GeneralInfo();
    }
  }
  async getServices(): Promise<any> {
    this.filterService.pageSize = 6;
    const rep = await this.servicesService.getListService(this.filterService);
    if (rep.data.length > 0) {
      this.services = rep.data as Service[];
      this.services = this.services.sort((a, b) => a.id - b.id);
    } else {
      this.services = [];
    }
  }

  async getPartners(): Promise<any> {
    this.filterPartner.pageSize = 20;
    const rep = await this.partnerService.getListPartner(this.filterPartner);
    if (rep.data.length > 0) {
      this.partners = rep.data as Partner[];
    } else {
      this.partners = [];
    }
  }

  getSocial(str) {
    if (str == "facebook") {
      return "fa-facebook";
    } else if (str == "twitter") {
      return "fa-twitter";
    } else if (str == "linkedin") {
      return "fa-linkedin";
    } else if (str == "google") {
      return "fa-google-plus";
    }
    return "bb";
  }
  // ------------ [/Data] ------------
}
